import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckInsToFacilitateCardQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CheckInsToFacilitateCardQuery = { __typename?: 'Query', MyPendingCheckinsToFacilitate: { __typename?: 'Assignments', totalCount: number, objects: Array<{ __typename?: 'Assignment', id: string, user: { __typename?: 'Employee', id: number, firstName: string } }> } };


export const CheckInsToFacilitateCardDocument = gql`
    query CheckInsToFacilitateCard {
  MyPendingCheckinsToFacilitate {
    totalCount
    objects {
      id
      user {
        id
        firstName
      }
    }
  }
}
    `;

/**
 * __useCheckInsToFacilitateCardQuery__
 *
 * To run a query within a React component, call `useCheckInsToFacilitateCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckInsToFacilitateCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckInsToFacilitateCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckInsToFacilitateCardQuery(baseOptions?: Apollo.QueryHookOptions<CheckInsToFacilitateCardQuery, CheckInsToFacilitateCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckInsToFacilitateCardQuery, CheckInsToFacilitateCardQueryVariables>(CheckInsToFacilitateCardDocument, options);
      }
export function useCheckInsToFacilitateCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckInsToFacilitateCardQuery, CheckInsToFacilitateCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckInsToFacilitateCardQuery, CheckInsToFacilitateCardQueryVariables>(CheckInsToFacilitateCardDocument, options);
        }
export type CheckInsToFacilitateCardQueryHookResult = ReturnType<typeof useCheckInsToFacilitateCardQuery>;
export type CheckInsToFacilitateCardLazyQueryHookResult = ReturnType<typeof useCheckInsToFacilitateCardLazyQuery>;
export type CheckInsToFacilitateCardQueryResult = Apollo.QueryResult<CheckInsToFacilitateCardQuery, CheckInsToFacilitateCardQueryVariables>;